import { render, staticRenderFns } from "./taskflow.vue?vue&type=template&id=6ce51dac"
import script from "./taskflow.vue?vue&type=script&lang=js"
export * from "./taskflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports